import React, { useEffect, useMemo, useState } from "react";
import { useConsultDoctor, useTicketHistory } from "../actionables/store";
import { Button, Form, Spinner } from "react-bootstrap";
import useStatsStore from "modules/engagement_report/engagement_stats/store";
import useAssignedStore from "modules/my_tickets/assigned_tickets/store";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { groupSlots } from "modules/utilities/utility";
import CardDiv from "modules/common/card-div/CardDiv";
import moment from "moment";
import { useToast } from "modules/navbar/top/store/toasterStore";
import _ from 'lodash';
import secureLocalStorage from "react-secure-storage";
import { MEDICAL_ESCALATION_INTERVENTION_DOCTOR } from 'config'

function MedicalSlotDisposition({ caseDetails, customerData, show, setSelectSlot, setFormData }) {
  const { fetchTicketHistory, ticketData } = useTicketHistory();
  const [reason, setReason] = useState("");
  const { setToaster } = useToast();
  const { bookedData, slotData, allSlotData, bookedLoading, allSlotLoading, isLoading, fetchOnboardingData, fetchDoctorSlotData, postDoctorSlotMedicalData} = useConsultDoctor();
  const [filterSlotData, setFilterSlotData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [doctor, setDoctor] = useState(null);
  const slotBooking = false;
  const [formData] = useState({
    first_name: customerData?.case?.user?.first_name,
    email: customerData?.case?.user?.email,
    phone_number: customerData?.case?.user?.phone_number,
  });
  // It may be required in future
  // const { users, fetchUserData  } = useStatsStore();
  const action_taker = secureLocalStorage.getItem("id");
  const { updateAssignedData } = useAssignedStore();

  useEffect(() => { if (caseDetails?.case_id) { fetchTicketHistory(caseDetails?.case_id); } }, [caseDetails.case_id]);
 

  const medicalEscalationTickets = ticketData
    .filter(ticket => ticket.category === "medical_escalations" && (ticket.status === "Open" || ticket.status === "Pending"))
    .reverse();
  const hasTicketData = medicalEscalationTickets.length > 0 && !isLoading;
  const ticket = hasTicketData ? medicalEscalationTickets[0] : null;
  const ticketId = _.get(ticket, '_id', '');
  const sub_category = _.get(ticket, 'sub_category', '');
  const doctorAssignmentCount = _.get(ticket, 'doctor_assignment_count', 0);

  const [medicalInterventionRequired, setMedicalInterventionRequired] = useState(false);

  const handleCheckboxChange = () => setMedicalInterventionRequired(!medicalInterventionRequired);

  const handleReasonChange = (event) => setReason(event.target.value);

// It can be required in future!.
// const interventionDocList = useMemo(() => {
//   return users
//   ?.filter((doctor) => {
//     if (doctor?.user?.meta?.is_intervention_doctor) {
//       return true;
//     }
//   })
//   .map((doctor) => {
//     return { label: doctor?.user?.first_name, value: doctor?.user_id };
//   });
// }, [users]);

  useEffect(() => {
    if (!isEmpty(bookedData)) {
      fetchDoctorSlotData(bookedData?.caseId, doctor, sub_category, toast);
    }
  }, [bookedData]);

  useEffect(() => {
    if (!isEmpty(slotData)) {
      const groupSlot = groupSlots(slotData);
      setFilterSlotData(groupSlot);
    } else {
      setFilterSlotData([]);
    }
  }, [slotData, allSlotData]);

  useEffect(() => {
    setFilterSlotData([]);
  }, [show]);

  const handleDate = (date) => {
    setSelectedDate(date);
    setSelectedSlot(null);
  };

  const handleClose = () => {
    setSelectedDate(null);
    setFilterSlotData(null);
    setSelectedSlot(null);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    fetchOnboardingData({ ...formData, gender: "M" }, toast);
    fetchDoctorSlotData(ticket.case_id, doctor, sub_category, toast);
    
  
  };
  

  const handleBookSlot = () => {
    const selectedSlotPayload = {
      from_crm: true,
      case_id: bookedData?.caseId,
      transaction_id: bookedData?.transactionId,
      consult_doctor_fees: "0",
      slot_time: selectedSlot?.slotTime,
      slots: selectedSlot?.slots,
    };
    const payloadEditTicket = {
      comment: {
        type: "medical_escalations",
        commented_by: action_taker,
        description: reason,
      },
      current_assignment: doctor,
      action_taker: action_taker,
      status_code: "3",
      doctor_assignment_count: doctorAssignmentCount + 1,
      slot: selectedSlot
    };

    postDoctorSlotMedicalData(selectedSlotPayload, toast, handleClose, payloadEditTicket, updateAssignedData, ticketId, setSelectSlot, selectedSlot, setToaster);
    setFormData((prevFormData) => ({ ...prevFormData, doctor_intervention_required: medicalInterventionRequired }));
  };

  return (
    <div className="mb-3">
      {hasTicketData && (
        <>
          <Form.Group className="mb-3 fs-1" style={{ marginTop: "15px" }}>
            <Form.Check
              type="checkbox"
              id="medicalInterventionCheckbox"
              label={<span className="fs-1">Doctor Intervention Required</span>}
              checked={medicalInterventionRequired}
              onChange={(e) => {
                handleCheckboxChange(e);
                handleSubmit(e);
              }}

            />
          </Form.Group>

          {medicalInterventionRequired && (
            <>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Reason for Doctor Intervention"
                  onChange={handleReasonChange}
                  defaultValue={reason}
                />
              </Form.Group>
              <div>
                <div>
                  {/* <div className="text-end">
                    <Form onSubmit={handleSubmit}>
                      <Form.Select
                        name="from_crm"
                        required
                        aria-label="Default select example"
                        onChange={(event) => setDoctor(event.target.value)}
                        className="border p-2"
                      >
                        <option value="">Please Select Doctor</option>
                        {interventionDocList?.map(doctor =>
                          <option value={doctor?.value}>
                            {doctor?.label}
                          </option>
                        )}
                      </Form.Select>
                      <Button
                        type="submit"
                        className="w-25 mt-4 py-2 text-center"
                      >
                        {bookedLoading ? (
                          <span className='d-flex gap-2'>
                            <><Spinner animation="border" size='sm' variant="light" /></>
                            <span>Submitting</span>
                          </span>
                        ) : (<span> Submit</span>)}
                      </Button>
                    </Form>
                  </div> */}
                  {slotBooking ? allSlotLoading ? fourPlaceHolder() : null : null}
                  <div className="d-flex gap-2 flex-wrap justify-content-center mt-3">
                    {filterSlotData &&
                      Object.keys(filterSlotData)?.map(slotDate =>
                        <div className="cursor-pointer" onClick={() => handleDate(slotDate)}>
                          <CardDiv
                            title={
                              <div className={slotDate == selectedDate ? "text-primary fw-bold" : "fw-bold"}>
                                {moment(slotDate).format("ddd DD")}
                              </div>
                            }
                            component={
                              <div className={slotDate == selectedDate ? "text-primary fw-bold" : "fw-bold"}>
                                {slotDate}
                              </div>
                            }
                          />
                        </div>
                      )
                    }
                  </div>
                  <div
                    className="d-flex gap-3 flex-wrap mt-5 scrollable-container"
                    style={{ maxHeight: "50vh", overflowY: "scroll" }}
                  >
                    {selectedDate &&
                      filterSlotData[selectedDate]?.map((timeSlot) => {
                        return (
                          <Button
                            style={{ width: "100px" }}
                            onClick={() => setSelectedSlot(timeSlot)}
                            className={
                              timeSlot?.slots?.count === 0
                                ? " py-2 fs-1 bg-secondary text-white rounded-5 cursor-na disabled pointer-events-none text-center"
                                : selectedSlot?.slotTime == timeSlot?.slotTime
                                  ? "py-2 fs-1 bg-success text-white rounded-5 cursor-pointer text-center"
                                  : " py-2 fs-1 rounded-5  bg-white text-black border border-secondary cursor-pointer text-center"
                            }
                          >
                            {moment(timeSlot?.slotTime).format("hh:mm A")}
                          </Button>
                        );
                      })}
                  </div>
                  {selectedSlot && (
                    <Button
                      className="mt-5 py-2 fs-1 w-100 "
                      onClick={handleBookSlot}
                    >
                      {isLoading ? (
                        <span className="d-flex flex-row gap-2 justify-content-center">
                          <Spinner animation="border" variant="light" />
                          <span>Booking Call Now</span>
                        </span>
                      ) : (
                        <span>Book Call Now</span>
                      )}
                    </Button>
                  )}
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default MedicalSlotDisposition;
